import { render, staticRenderFns } from "./DropMenuButton.vue?vue&type=template&id=2ace3c98&scoped=true&"
import script from "./DropMenuButton.vue?vue&type=script&lang=js&"
export * from "./DropMenuButton.vue?vue&type=script&lang=js&"
import style0 from "./DropMenuButton.vue?vue&type=style&index=0&id=2ace3c98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ace3c98",
  null
  
)

export default component.exports